// Define the API URL we are going to use

let apiUrl = '';
let authEndpoint = '';

// Depending on the environment, use the corresponding API URL
switch (process.env.VUE_APP_NODE_ENV) {
    case 'development':
        apiUrl = 'https://api.pharmamonitor.test.pharmainsights.se/api/v1';
        authEndpoint = 'https://api.pharmamonitor.test.pharmainsights.se/api/v1/broadcasting/auth';
        break;
    case 'staging':
        apiUrl = 'https://api.pharmamonitor.test.pharmainsights.se/api/v1';
        authEndpoint = 'https://api.pharmamonitor.test.pharmainsights.se/api/v1/broadcasting/auth';
        break;
    case 'production':
        apiUrl = 'https://api.pharmamonitorexpress.se/api/v1';
        authEndpoint = 'https://api.pharmamonitorexpress.se/api/v1/broadcasting/auth';
        break;
    default:
        apiUrl = 'https://api.pharmamonitor.test.pharmainsights.se/api/v1';
        authEndpoint = 'https://api.pharmamonitor.test.pharmainsights.se/api/v1/broadcasting/auth';
}

// Export API URL
export const PMX_DASHBOARD_CONFIG = {
    API_URL: apiUrl,
    AUTH_ENDPOINT: authEndpoint
};